import { getPropertyRates } from 'api/accommodation'
import buildPropertyRatesKey from 'lib/offer/buildPropertyRatesKey'

import { API_CALL } from './actionConstants'
import { FETCH_PROPERTY_RATES } from './apiActionConstants'
import type { AppAction } from './types/ActionTypes'

interface PropertyRatesParams {
  checkIn: string;
  checkOut: string;
  occupancies: Array<App.Occupants>;
  dynamicAvailability: boolean;
}

export function fetchPropertyRates(propertyId: string, {
  checkIn,
  checkOut,
  occupancies,
  dynamicAvailability,
}: PropertyRatesParams): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = buildPropertyRatesKey({
      propertyId,
      checkIn,
      checkOut,
      occupancies,
      dynamicAvailability,
    })
    // NB: For better or worse, we have no TTL on cached responses, so rates _will_ become stale and
    // errors _won't_ clear until a hard refresh.
    if (!key || state.offer.propertyRates[key]) return

    dispatch({
      type: API_CALL,
      api: FETCH_PROPERTY_RATES,
      request: () => getPropertyRates(propertyId, {
        checkIn,
        checkOut,
        occupancies,
        regionCode: state.geo.currentRegionCode,
        currency: state.geo.currentCurrency,
        previewMode: state.system.previewMode,
        dynamicAvailability,
      }),
      key,
    })
  }
}
